import { Box, Grid, IconButton, TextField } from "@mui/material";
import { useContext } from "react";
import Editor from "@monaco-editor/react";

import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { Context } from "./Context";
import { useTranslation } from "react-i18next";

const Params = ({ category, query }) => {
	const { t } = useTranslation();

	const { params, setParams } = useContext(Context);

	return (
		<>
			{params
				.filter(
					(param) =>
						param.category === category && param.query === query
				)
				.map((param, index) => (
					<Grid container spacing={2} sx={{ mt: 1.5 }}>
						<Grid item xs={4} width={"25%"}>
							<Box
								sx={{
									display: "flex",
									gap: 1,
									justifyContent: "center",
									alignContent: "center",
								}}
							>
								<IconButton
									color="error"
									onClick={() => {
										setParams(
											params.filter(
												(p) =>
													!(
														p.category ===
															param.category &&
														p.query ===
															param.query &&
														p.name === param.name
													)
											)
										);
									}}
								>
									<DeleteIcon />
								</IconButton>

								<TextField
									fullWidth
									label={t(
										"custom_reports.reports.table.dialog.edit_api.param"
									)}
									value={param.name}
									onChange={(e) => {
										setParams(
											params.map((p) => {
												if (
													p.category ===
														param.category &&
													p.query === param.query &&
													p.name === param.name
												) {
													return {
														...p,
														name: e.target.value,
													};
												}

												return p;
											})
										);
									}}
									variant="outlined"
									size="small"
								/>
							</Box>
						</Grid>

						<Grid item xs={8} width={"72.7%"}>
							<TextField
								fullWidth
								label={t(
									"custom_reports.reports.table.dialog.edit_api.field"
								)}
								value={param.value}
								onChange={(e) => {
									setParams(
										params.map((p) => {
											if (
												p.category === param.category &&
												p.query === param.query &&
												p.name === param.name
											) {
												return {
													...p,
													value: e.target.value,
												};
											}

											return p;
										})
									);
								}}
								variant="outlined"
								size="small"
							/>
						</Grid>
					</Grid>
				))}

			<br />

			<center>
				<IconButton
					onClick={() => {
						setParams([
							...params,
							{
								category: category,
								query: query,
								name: "",
								value: "",
							},
						]);
					}}
				>
					<AddIcon />
				</IconButton>
			</center>
		</>
	);
};

const Query = ({ category }) => {
	const { t } = useTranslation();

	const { queries, setQueries } = useContext(Context);

	return (
		<>
			{queries
				.filter((query) => query.category === category.name)
				.map((query, index) => (
					<Grid container spacing={2} sx={{ mb: 2.5 }}>
						<Grid item xs={4}>
							<Box
								sx={{
									display: "flex",
									gap: 1,
									justifyContent: "center",
									alignContent: "center",
								}}
							>
								<IconButton
									color="error"
									onClick={() => {
										setQueries(
											queries.filter(
												(q) =>
													!(
														q.category ===
															category.name &&
														q.name === query.name
													)
											)
										);
									}}
								>
									<DeleteIcon />
								</IconButton>

								<TextField
									fullWidth
									label={t(
										"custom_reports.reports.table.dialog.edit_api.name"
									)}
									value={query.name}
									onChange={(e) =>
										setQueries(
											queries.map((q) => {
												if (
													q.category ===
														category.name &&
													q.name === query.name
												) {
													return {
														...q,
														name: e.target.value,
													};
												}

												return q;
											})
										)
									}
									variant="outlined"
									size="small"
									sx={{
										width: "100%",
									}}
								/>
							</Box>
						</Grid>

						<Grid item xs={8} sx={{ width: "73%" }}>
							<Box
								sx={{
									border: (theme) =>
										`1px solid ${theme.palette.divider}`,
									borderRadius: "5px",
								}}
							>
								<Editor
									height="150px"
									defaultLanguage="sql"
									value={query.string}
									theme="vs-dark"
									onChange={(value) => {
										setQueries(
											queries.map((q) => {
												if (
													q.category ===
														category.name &&
													q.name === query.name
												) {
													return {
														...q,
														string: value,
													};
												}

												return q;
											})
										);
									}}
									options={{
										minimap: { enabled: false },
									}}
								/>
							</Box>

							<Params
								category={query.category}
								query={query.name}
							/>
						</Grid>
					</Grid>
				))}
		</>
	);
};

export { Query };
